import { tools } from "../const/data";
import TransitionText from "../components/TransitionText";
import { dict } from "../const/dict";

const Tools = () => {
  return (
    <div className="section page-container">
      <div className="flex flex-col justify-start">
        <TransitionText text={dict.toolsAndRequirements} wrapperClassName="justify-center" />
        <p className="xl:mt-5 mt-2 text-description text-center">
          {dict.tools1}
          <br />
          {dict.tools2}
        </p>
        <div className="xl:flex flex-col hidden justify-center items-center gap-5 mt-10">
          <div className="flex gap-5 h-16">
            {tools.slice(0, 10).map((item) => (
              <img
                src={require(`../assets/images/techs/${item}.png`)}
                className="icon-transition"
                width={65}
                alt={item}
              />
            ))}
          </div>
          <div className="flex gap-5 h-16 justify-center">
            {tools.slice(10).map((item) => (
              <img
                src={require(`../assets/images/techs/${item}.png`)}
                className="icon-transition"
                width={65}
                alt={item}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4 xl:hidden justify-center items-center">
          {[...tools].map((item) => (
            <img
              src={require(`../assets/images/techs/${item}.png`)}
              className="icon-transition w-8 h-8"
              alt={item}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tools;
